// Set of helper functions to facilitate wallet setup

/**
 * Prompt the user to add BSC as a network on Metamask, or switch to BSC if the wallet is on a different network
 * @returns {boolean} true if the setup succeeded, false otherwise
 */
import { connectorsByName } from "../utils/web3React";
export const setupNetwork = async (chainId) => {
  let provider = "";
  // connectorsByName
  // console.log(provider, "providerproviderprovider");
  const connectorId =
    typeof window !== "undefined"
      ? window.localStorage.getItem("connectorId")
      : null;
  if (connectorId === "injected") {
    provider = window.ethereum;
  } else {
    if (connectorsByName.walletconnect.provider) {
      provider = connectorsByName.walletconnect.provider;
    }
  }
  if (provider) {
    // const chainId = parseInt(process.env.REACT_APP_CHAIN_ID, 10);
    // console.log("chain id here is", chainId)
    // const chainId = 4
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${chainId.toString(16)}`,
            // chainName: 'Rinkeby Smart Chain TestNet',
            // nativeCurrency: {
            //   name: 'ETH',
            //   symbol: 'ETH',
            //   decimals: 18,
            // },
            // rpcUrls: [nodes],
            // blockExplorerUrls: ['https://rinkeby.etherscan.com/'],
          },
        ],
      });
      return true;
    } catch (error) {
      if (error.code === 4902 && chainId !== 1) {
        try {
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: `0x${chainId.toString(16)}`,
                chainName: "Base Mainnet",
                nativeCurrency: {
                  name: "Base",
                  symbol: "ETH",
                  decimals: 18,
                },
                rpcUrls: ["https://base.drpc.org"],
                blockExplorerUrls: ["https://base.blockscout.com/"],
              },
            ],
          });
          return true;
        } catch (addError) {
          console.error("Failed to add the network:", addError);
          return false;
        }
      } else {
        console.error("Failed to switch the network:", error);
        return false;
      }
    }
  } else {
    console.error(
      "Can't setup the BSC network on metamask because window.ethereum is undefined"
    );
    return false;
  }
};
/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @param tokenImage
 * @returns {boolean} true if the token has been added, false otherwise
 */
export const registerToken = async (
  tokenAddress,
  tokenSymbol,
  tokenDecimals,
  tokenImage
) => {
  const tokenAdded = await window.ethereum.request({
    method: "wallet_watchAsset",
    params: {
      type: "ERC20",
      options: {
        address: tokenAddress,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        image: tokenImage,
      },
    },
  });

  return tokenAdded;
};
